import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { ListOfCertificates, PaginationParams } from '../hardware-certificates.interface';
import { TranslateService } from '@ngx-translate/core';
import { BusinessService } from '@app/business/business.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '@app/core';

@Component({
  selector: 'cloud-business-hardware-certificates-table',
  templateUrl: './business-hardware-certificates-table.component.html',
  styleUrls: ['./business-hardware-certificates-table.component.scss']
})
export class BusinessHardwareCertificatesTableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild(BusinessHardwareCertificatesTableComponent, { static: false }) certificateTable: BusinessHardwareCertificatesTableComponent;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Input() hardwareCertificates: ListOfCertificates[] = [];
  @Input() totalCount: number = 0;
  @Input() loading: boolean = false;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;

  @Output() pageChange = new EventEmitter<PaginationParams>();

  @Output() sortChange = new EventEmitter<Sort>();

  unsubscribe$: Subject<void> = new Subject<void>();
  certificatesDataSource: any;

  readonly displayedColumns = [
    'type',
    'serialNumber',
    'clientName',
    'clientIdentification',
    'validFrom',
    'validTo',
    'status',
    'actions'
  ];
  order: string = 'ASC';
  orderByFilter: string = '';
  companyCmrId: string;
  offsetValue: number = 0;
  limitPage: number = 10;
  hasPaging: boolean = true;

  constructor(
    private translateService: TranslateService,
    public businessService: BusinessService,
    private router: Router,
    private sessionStorageService: SessionStorageService,
  ) { }

  ngOnInit(): void {
    this.companyCmrId = this.sessionStorageService.getItem("businessAccountId");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hardwareCertificates) {
      this.certificatesDataSource = [...this.hardwareCertificates];
    }

    if (changes.totalCount && this.paginator) {
      this.paginator.length = this.totalCount;
    }

    if (changes.pageSize && this.paginator) {
      this.paginator.pageSize = this.pageSize;
    }

    if (changes.pageIndex && this.paginator) {
      this.paginator.pageIndex = this.pageIndex;
    }
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.length = this.totalCount;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = this.pageIndex;
    }

    if (this.sort) {
      this.sort.sortChange.subscribe((sortEvent: Sort) => {
        this.onSortEvent(sortEvent);
      });
    }
  }

  mapCertificateType(name) {
    switch (name) {
      case 'QES':
        return this.translateService.instant('certificates.certificateType.qesPersonal');
      case 'QESP':
        return this.translateService.instant('certificates.certificateType.qesProfessional')
    }
  }
  mapCertificateStatus(status: string) {
    switch (status) {
      case "EXPIRED":
        return this.translateService.instant('certificates.certificateStatus.expired');
      case "HOLDED":
        return this.translateService.instant('certificates.certificateStatus.holded');
      case "NOT_ACTIVATED":
        return this.translateService.instant('certificates.certificateStatus.notActivated');
      case "PENDING_HOLD":
        return this.translateService.instant('certificates.certificateStatus.pendingHold');
      case "PENDING_RESTORE":
        return this.translateService.instant('certificates.certificateStatus.pendingRestore');
      case "PENDING_REVOKE":
        return this.translateService.instant('certificates.certificateStatus.pendingRevoke');
      case "REVOKED":
        return this.translateService.instant('certificates.certificateStatus.revoked');
      case "VALID":
        return this.translateService.instant('certificates.certificateStatus.valid');
      case "WAITING_ACTIVATION":
        return this.translateService.instant('certificates.certificateStatus.waitingActivation');
    }
  }

  checkQualified(cert) {
    if (cert && (cert.certificateType == 'CQES' || cert.certificateType == 'OTC-RP-BASED-ID')) {
      return false;
    }
    let check = cert.certCa == null ? false : cert.certCa.indexOf("Qualified") !== -1;
    return check;
  }

  hasData(): boolean {
    return this.hardwareCertificates && Array.isArray(this.hardwareCertificates) && this.hardwareCertificates.length > 0;
  }

  routeToHistory(row: any) {
    this.businessService.setRowHistory(row);
    this.router.navigate(['business/certificateHistory']);
  }
  routeToManagment(row: any) {
    this.businessService.setRow(row);
    this.router.navigate(['business/menageHardwareCertificates']);

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  isCertTypePersonal(row: any): boolean {
    return row?.type?.toLowerCase().includes('персонален') ?? false;
  }

  onPageEvent(event: PageEvent): void {
    this.pageChange.emit({
      pageIndex: event.pageIndex,
      pageSize: event.pageSize
    });
  }

  onSortEvent(sort: Sort): void {
    this.orderByFilter = sort.active;
    this.order = sort.direction === 'asc' ? 'ASC' : 'DESC';

    this.sortChange.emit({
      active: sort.active,
      direction: sort.direction as 'asc' | 'desc' | ''
    });
  }
}
